import { BlueskyRecommendationKey } from '$extensionSrc/utils/enums'

import * as bluesky2fa from './bluesky2fa'
import * as blueskyDeletePostsBefore from './blueskyDeletePostsBefore'
import {
  getAccountUsernameGatherStageDefs,
  getAdditionalFullGatherStageDefs,
  isAccountDataGathered,
} from './blueskyGatherMachine'
import * as blueskyGatherVerifiedDomain from './blueskyGatherVerifiedDomain'
import * as blueskyMessages from './blueskyMessages'
import * as blueskyPostInteractions from './blueskyPostInteractions'
import {
  RecommendationAutomationRegistryApi,
  RecommendationAutomationRegistry,
} from '../automationMachineInterfaces'
import * as manualRecommendation from '../manualRecommendation'

const REGISTRY: RecommendationAutomationRegistry = {
  [BlueskyRecommendationKey.BLUESKY_2FA]: bluesky2fa,
  [BlueskyRecommendationKey.BLUESKY_DELETE_POSTS_BEFORE]:
    blueskyDeletePostsBefore,
  [BlueskyRecommendationKey.BLUESKY_DOMAIN_VERIFICATION]:
    blueskyGatherVerifiedDomain,
  [BlueskyRecommendationKey.BLUESKY_MESSAGES]: blueskyMessages,
  [BlueskyRecommendationKey.BLUESKY_MODERATION]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        BlueskyRecommendationKey.BLUESKY_MODERATION,
      ),
    ],
  },
  [BlueskyRecommendationKey.BLUESKY_FEEDS]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        BlueskyRecommendationKey.BLUESKY_FEEDS,
      ),
    ],
  },
  [BlueskyRecommendationKey.BLUESKY_POST_INTERACTIONS]: blueskyPostInteractions,
}

export const blueskyRegistry: RecommendationAutomationRegistryApi = {
  getAccountUsernameGatherStageDefs,
  getAdditionalFullGatherStageDefs,
  getRecommendationAutomationRegistry: () => REGISTRY,
  isAccountDataGathered: (accountData) => isAccountDataGathered(accountData),
}
